module.exports = {
	"id": "as",
	"name": "Asia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.003573,
			"5": 0.003573,
			"6": 0.003573,
			"7": null,
			"8": 0.003573,
			"9": null,
			"10": 0.007146,
			"11": 0.032157,
			"12": 0.010719,
			"13": 0.003573,
			"14": 0.007146,
			"15": 0.007146,
			"16": 0.007146,
			"17": 0.007146,
			"18": 0.010719,
			"19": 0.010719,
			"20": 0.010719,
			"21": 0.014292,
			"22": 0.057168,
			"23": 0.014292,
			"24": 0.017865,
			"25": 0.017865,
			"26": 0.028584,
			"27": 0.017865,
			"28": 0.021438,
			"29": 0.025011,
			"30": 0.021438,
			"31": 0.139347,
			"32": 0.017865,
			"33": 0.053595,
			"34": 0.03573,
			"35": 0.025011,
			"36": 0.017865,
			"37": 0.014292,
			"38": 0.03573,
			"39": 0.046449,
			"40": 0.032157,
			"41": 0.021438,
			"42": 0.092898,
			"43": 0.289413,
			"44": 0.060741,
			"45": 0.578826,
			"46": 0.092898,
			"47": 0.164358,
			"48": 0.128628,
			"49": 1.379178,
			"50": 0.242964,
			"51": 0.510939,
			"52": 0.425187,
			"53": 14.091912,
			"54": 3.730212,
			"55": 0.089325,
			"56": 0.025011,
			"57": null
		},
		"firefox": {
			"2": 0.003573,
			"3": 0.057168,
			"4": 0.007146,
			"5": 0.003573,
			"6": null,
			"7": null,
			"8": 0.028584,
			"9": 0.003573,
			"10": 0.007146,
			"11": 0.007146,
			"12": 0.014292,
			"13": 0.007146,
			"14": 0.007146,
			"15": 0.010719,
			"16": 0.010719,
			"17": 0.007146,
			"18": 0.010719,
			"19": 0.007146,
			"20": 0.007146,
			"21": 0.010719,
			"22": 0.007146,
			"23": 0.010719,
			"24": 0.007146,
			"25": 0.014292,
			"26": 0.007146,
			"27": 0.007146,
			"28": 0.010719,
			"29": 0.017865,
			"30": 0.014292,
			"31": 0.028584,
			"32": 0.010719,
			"33": 0.017865,
			"34": 0.017865,
			"35": 0.021438,
			"36": 0.021438,
			"37": 0.025011,
			"38": 0.039303,
			"39": 0.028584,
			"40": 0.028584,
			"41": 0.032157,
			"42": 0.028584,
			"43": 0.132201,
			"44": 0.075033,
			"45": 0.075033,
			"46": 0.067887,
			"47": 0.332289,
			"48": 0.260829,
			"49": 2.247417,
			"50": 0.221526,
			"51": 0.003573,
			"52": null,
			"3.5": 0.007146,
			"3.6": 0.025011
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.007146,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.003573,
			"29": null,
			"30": 0.003573,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.010719,
			"35": 0.003573,
			"36": 0.014292,
			"37": 0.064314,
			"38": 0.03573,
			"39": 0.010719,
			"40": 0.221526,
			"41": 0.03573,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.003573,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.007146,
			"12.1": 0.028584
		},
		"safari": {
			"0": null,
			"4": 0.007146,
			"5": 0.014292,
			"6": 0.007146,
			"7": 0.014292,
			"8": 0.050022,
			"9": 0.050022,
			"10": 0.275121,
			"3.1": null,
			"3.2": null,
			"5.1": 0.025011,
			"6.1": 0.014292,
			"7.1": 0.007146,
			"9.1": 0.200088
		},
		"ios_saf": {
			"8": 0,
			"10": 4.6878409567,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.126331889363,
			"8.1-8.4": 0.233392812552,
			"9.0-9.2": 0.111343360117,
			"9.3": 1.69869998127
		},
		"android": {
			"3": 0,
			"4": 0.0706803927649,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00883504909561,
			"4.1": 0.254954273902,
			"4.2-4.3": 0.637385684755,
			"4.4": 1.46156955039,
			"4.4.3-4.4.4": 1.4741910491
		},
		"ie": {
			"6": 0.0420039170616,
			"7": 0.0229112274882,
			"8": 0.530776770142,
			"9": 0.267297654028,
			"10": 0.217656661137,
			"11": 2.13456269431,
			"5.5": null
		},
		"op_mob": {
			"0": 0.359453788864,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00998482746845
		},
		"edge": {
			"12": 0.046449,
			"13": 0.17865,
			"14": 0.353727
		},
		"ie_mob": {
			"10": 0.0950471830986,
			"11": 0.386977816901
		},
		"bb": {
			"7": 0.0482025,
			"10": null
		},
		"samsung": {
			"0": 3.753368
		},
		"and_uc": {
			"0": 18.432636
		},
		"op_mini": {
			"0": 4.84285838367
		},
		"and_chr": {
			"0": 27.265204
		},
		"and_ff": {
			"0": 0.025708
		}
	},
	"total": 97.6552464242
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/alt-as.json
 ** module id = 691
 ** module chunks = 0
 **/